import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { Slot, BookAppointmentResponse } from '../types';
import { showNotification } from '@/utils/notificationUtils';
export type SyncAppointmentDTO = {
  data: {
    businessId?: number;
  };
};

export const syncAppointment = ({ data }: SyncAppointmentDTO): Promise<Slot[]> => {
  return axios.post(`/business/calendar/sync`, data);
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof syncAppointment>;
};

export const useSyncAppointment = ({ config }: UseUpdateBusinessOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Synced successfully',
      });
    },
    ...config,
    mutationFn: syncAppointment,
  });
};
